// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"-all-wrapper-2sdzH6-","cli-card":"-all-cli-card-1qSWKx-","cli-table":"-all-cli-table-16WDkr-","cli-table-th":"-all-cli-table-th-1DP9nD-"};


//////////////////
// WEBPACK FOOTER
// ./src/views/clients/all.css
// module id = 318
// module chunks = 0